import { render, staticRenderFns } from "./slideForm.vue?vue&type=template&id=8c0cd3e2&scoped=true"
import script from "./slideForm.vue?vue&type=script&lang=js"
export * from "./slideForm.vue?vue&type=script&lang=js"
import style0 from "./slideForm.vue?vue&type=style&index=0&id=8c0cd3e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0cd3e2",
  null
  
)

export default component.exports